export const defaultQrCodeBullets: string[] = [
    "Metody leczenia i postępowanie ortopedyczne",
    "Zalecenia przed i po zabiegach",
    "Informacje o operacjach i terapiach",
    "Możliwość rejestracji wizyty u specjalisty",
];
